import { Component, OnInit, Input, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DragScrollComponent } from 'ngx-drag-scroll';
import { CoreService } from 'src/app/core/services/core.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'bs-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements AfterViewInit {
  @ViewChild('instagramScroll', {read: DragScrollComponent}) ids: DragScrollComponent;
  thisYear = new Date().getUTCFullYear();
  companyName = 'British Shooting Ltd';
  public social;
  timeRemaining = 45;

  constructor(
    public coreService: CoreService,
    public dialogRef: MatDialogRef<SplashScreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.companyName = environment.companyName;
    this.social = environment.social;
    if (data.ttl) {
      this.timeRemaining = parseInt(data.ttl, 10);
    }
  }
  close(link = null): void {
    this.dialogRef.close({
      link,
    });
  }
  startSlideShow(ds, interval = 2500) {
    return setInterval(() => {
      if (ds.currIndex + 1 < ds.indexBound) {
        ds.moveTo(ds.currIndex + 1);
      } else {
        ds.moveTo(0);
      }
    }, interval);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.startSlideShow(this.ids);
    }, 2500);

    setInterval(() => {
      this.timeRemaining--;
      if (this.timeRemaining === 0) {
        this.close();
      }
    }, 1000);
  }
}
